import sessionApi from '../api/sessionApi'
import * as types from './actionTypes'

export function smsSent(status) {
  return { type: types.SMS_SENT, userStatus: status }
}

const clearErrors = () => ({
  type: types.CLEAR_ALL_ERRORS
})

const setUserPhone = phone => ({
  type: types.SET_USER_PHONE,
  phone
})

export function sendSMS(phone) {
  return function(dispatch) {
    return sessionApi
      .sendSMS(phone)
      .then(response => {
        dispatch(clearErrors())
        localStorage.setItem('userStatus', response.data.state)
        dispatch(setUserPhone(phone))
        return dispatch(smsSent(response.data.state))
      })
      .catch(error => {
        throw error
      })
  }
}

const activateCode = jwt => ({
  type: types.ACTIVATE_CODE,
  jwt
})

export const sendCode = (phone, code) => dispatch => {
  sessionApi
    .activatePhone(phone, code)
    .then(response => {
      localStorage.setItem('jwt', response.data.jwt)
      dispatch(clearErrors())
      return dispatch(activateCode(response.data.jwt))
    })
    .catch(err =>
      dispatch({
        type: types.INVALID_CODE,
        msg: 'Введенный вами код неверен'
      })
    )
}

export const logOut = () => dispatch =>
  sessionApi
    .logOut()
    .then(() => {
      localStorage.clear()
      sessionStorage.clear()
      setTimeout(() => dispatch({ type: types.LOG_OUT }))
    })
    .catch(err => console.log(err))

const setVideoData = videoData => ({
  type: types.SET_VIDEO_DATA,
  videoData
})

export const getVideoData = () => dispatch =>
  sessionApi
    .getVideoData()
    .then(response => {
      if (response.status === 200) {
        return dispatch(setVideoData(response.data.stream.rtsp))
      }
    })
    .catch(err => console.log(err))

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

export const registerAccount = (firstname, lastname, file) => dispatch => {
  if (file) {
    getBase64(file).then(imageBase64 => {
      console.log(imageBase64)
      sessionApi
        .setAccountSettings({
          first_name: firstname,
          last_name: lastname,
          avatar: imageBase64
        })
        .then(response => {
          console.log(response)
          localStorage.setItem('userStatus', 'registered')
          dispatch(setAccountSettings(response.data))
          return dispatch({
            type: types.REGISTERED,
            userStatus: response.data.state
          })
        })
        .catch(err => console.log(err))
    })
  } else {
    sessionApi
      .setAccountSettings({ first_name: firstname, last_name: lastname })
      .then(response => {})
  }
}

export const setUserStatus = status => dispatch => {
  localStorage.setItem('userStatus', status)
  return dispatch({
    type: types.SET_USER_STATUS,
    status
  })
}

const setAccountSettings = settings => ({
  type: types.SET_CURRENT_USER,
  currentUser: settings
})

export const getAccountSettings = () => dispatch =>
  sessionApi
    .getAccountSettings()
    .then(response => dispatch(setAccountSettings(response.data)))
    .catch(err => console.log(err))

export const openDoor = () => dispatch =>
  sessionApi
    .openDoor()
    .then(response => console.log(response))
    .catch(err => console.log(err))

export const sendFeedback = (title, text) =>
  sessionApi
    .sendFeedback(title, text)
    .then(response => console.log(response))
    .catch(err => console.err(err))

const setActivationCode = code => ({
  type: types.SET_ACTIVATION_CODE,
  code
})

export const getActivationCode = () => dispatch =>
  sessionApi.getActivationCode().then(response => {
    sessionStorage.setItem('activationCode', response.data.code)
    dispatch(setActivationCode(response.data.code))
  })



// WEBPACK FOOTER //
// ./src/actions/sessionActions.js